export const REMOTE_DC_DEFAULT_SIMILARITY_THRESHOLD_PCT = 90;
export const REMOTE_DC_DEFAULT_DELTA_THRESHOLD_PCT = 4;
export const REMOTE_DC_DEFAULT_SSM_CONFIDENCE_THRESHOLD_PCT = 60;
export const REMOTE_DC_DEFAULT_SEARCH_SIZE = 500;
export const REMOTE_DC_MAX_SEARCH_SIZE = 5000;
export const REMOTE_DC_DEFAULT_SAMPLE_SIZE = 50;
export const REMOTE_DC_MAX_SAMPLE_SIZE = 1000;
export const REMOTE_DC_DEFAULT_LOOKBACK_HOURS = 24;
export const REMOTE_DC_DEFAULT_MERGE_LINKED_CANDIDATES = true;
export const REMOTE_DC_DEFAULT_LOW_EMBEDDING_THRESHOLD = 3;
export const REMOTE_DC_DEFAULT_INCLUDE_SIMILARITY_PRIORITY = true;
export const REMOTE_DC_DEFAULT_INCLUDE_DELTA_PRIORITY = true;
export const REMOTE_DC_DEFAULT_SIMILARITY_PRIORITY_WEIGHT = 1;
export const REMOTE_DC_DEFAULT_DELTA_PRIORITY_WEIGHT = 1;
export const REMOTE_DC_DEFAULT_LOW_EMBEDDING_PRIORITY_WEIGHT = 1;
export const REMOTE_DC_DEFAULT_PRODUCT_PRIORITY_WEIGHT = 1;
export const REMOTE_DC_DEFAULT_CARTON_PRIORITY_WEIGHT = 1;
export const REMOTE_DC_DEFAULT_DETECTED_POLYGON_NORMALIZATION_PCT = 0;
export const REMOTE_DC_DEFAULT_SKIP_INFERENCES_WITHOUT_POGS = true;
export const REMOTE_DC_DEFAULT_UNSTRUCTURED_POG_FILTER = 'skip_if_all';
